import React from 'react';

const RoomImage = () => {
    return (
        <>
            <img src="assets/rooms/standard-king_playacar.jpg" alt=""/>
        </>
    );
};

export default RoomImage;
